import { TUser } from "../server/types";

const TOKEN = 'token';
const USER = 'user';
const AI_MODEL = 'ai_model';

class Store {
    user: TUser | null = null;

    setToken(token: string): void {
        localStorage.setItem(TOKEN, token);
    }

    getToken(): string | null {
        return localStorage.getItem(TOKEN);
    }

    /**
     * Сохранить пользователя в localStorage
     */
    saveUserToStorage(user: TUser): void {
        try {
            localStorage.setItem(USER, JSON.stringify(user));
        } catch (e) {
            console.error('Failed to save user to localStorage:', e);
        }
    }

    /**
     * Загрузить пользователя из localStorage
     */
    loadUserFromStorage(): TUser | null {
        try {
            const userStr = localStorage.getItem(USER);
            if (userStr) {
                return JSON.parse(userStr);
            }
        } catch (e) {
            console.error('Failed to load user from localStorage:', e);
            // Очищаем поврежденные данные
            localStorage.removeItem(USER);
        }
        return null;
    }

    setUser(user: TUser): void {
        const { token } = user;
        this.setToken(token);
        this.user = user;
        this.saveUserToStorage(user);
    }

    getUser(): TUser | null {
        return this.user;
    }

    clearUser(): void {
        this.user = null;
        this.setToken('');
        localStorage.removeItem(USER);
    }

    setUserName(newName: string): void {
        // Обновляем свойство name в текущем объекте пользователя
        if (this.user) {
            this.user.name = newName;
            this.saveUserToStorage(this.user);
        }
    }

    /**
     * Сохранить выбранную модель AI
     */
    setAIModel(model: string): void {
        try {
            localStorage.setItem(AI_MODEL, model);
        } catch (e) {
            console.error('Failed to save AI model to localStorage:', e);
        }
    }

    /**
     * Получить выбранную модель AI
     */
    getAIModel(): string {
        try {
            return localStorage.getItem(AI_MODEL) || 'nvidia/nemotron-3-nano-30b-a3b:free';
        } catch (e) {
            console.error('Failed to load AI model from localStorage:', e);
            return 'nvidia/nemotron-3-nano-30b-a3b:free';
        }
    }
}

export default Store;